import { render, staticRenderFns } from "./discovery-card.vue?vue&type=template&id=6e7ef3a4&scoped=true&"
import script from "./discovery-card.vue?vue&type=script&lang=js&"
export * from "./discovery-card.vue?vue&type=script&lang=js&"
import style0 from "./discovery-card.vue?vue&type=style&index=0&id=6e7ef3a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ef3a4",
  null
  
)

export default component.exports